import { css } from 'aphrodite';
import { useCoachingConversationCallView } from '../../../queries/AIConversation/useCoachingConversationCallView';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { useManagerPermissions } from '../../hooks/useManagerPermissions';
import { AdherenceBreakdown } from './CoachingAdherence';
import { styleSheet } from './styles';

interface IProps {
	conversationId: string | null;
}

export function AdherencePanel({ conversationId }: IProps) {
	const { hasManagerPermissions, isLoading: permissionsLoading } = useManagerPermissions();
	const { callView, isLoading } = useCoachingConversationCallView(conversationId);

	if (!conversationId || permissionsLoading || !hasManagerPermissions) {
		return null;
	}

	const result = callView?.phoneCall?.coachingAdherenceResult ?? null;

	const renderBody = () => {
		if (isLoading) {
			return (
				<div className={css(styleSheet.insightsSpinner)}>
					<LoadingSpinner type='small' />
				</div>
			);
		}
		if (!result) {
			return (
				<div className={css(styleSheet.adherenceEmpty)}>
					No coaching adherence analysis found for this conversation.
				</div>
			);
		}
		return <AdherenceBreakdown result={result} />;
	};

	return (
		<section className={css(styleSheet.adherence)} aria-label='Adherence'>
			<div className={css(styleSheet.metadataHeader)}>
				<h3 className={css(styleSheet.metadataTitle)}>Adherence</h3>
			</div>
			<div className={css(styleSheet.adherenceBody)}>{renderBody()}</div>
		</section>
	);
}
